module.exports = __webpack_public_path__ + "img/ideas-submit-banner-1600x900.a74cfb06.png";